export default {
  lobby:{
    pano:"./lobby.jpg",
    marks: [
      {
        id: "welcome",
        polylineRad: [
          [2.51, 0.51],
          [3.766, 0.51],
          [3.766, -0.21],
          [2.51, -0.21],
          [2.51, 0.51]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Bienvenido",
          position: "right bottom"
        },
        info: {
          template: "welcome"
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [1.4395, 0.176],
          [1.87, 0.171],
          [1.87, -0.233],
          [1.4395, -0.233],
          [1.4395, 0.176]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Acceso a la exposición, Sala 1",
          position: "center bottom"
        }
      },
      {
        id: "link:game:0", // cmd, arg, marker id
        polylineRad: [
          [4.41, 0.180],
          [4.85, 0.185],
          [4.85, -0.24],
          [4.41, -0.23],
          [4.41, 0.180]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Acceso a la Sala Lúdica",
          position: "center bottom"
        }
      },
      {
        id: "credits",
        polylineRad: [
          [5.228, 0.332],
          [5.226, -0.149],
          [5.742, -0.09],
          [5.742, 0.2],
          [5.228, 0.332]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Créditos de la exposición:",
          position: "right bottom"
        },
        info: {
          title: "Línea del tiempo del siglo XIX",
          template: "credits",
          images: [
          ],
          audios: [
          ]
        }
      },
      {
        id: "instituciones",
        polylineRad: [
          [1.05, 0.468],
          [1.05, -0.146],
          [0.554, -0.09],
          [0.553, 0.299],
          [1.05, 0.468]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Agradecimientos de la exposición",
          position: "right bottom"
        },
        info: {
          title: "Línea del tiempo del siglo XIX",
          template: "instituciones",
          images: [
          ],
          audios: [
          ]
        }
      },
    ]
  },
  sala1_1:{
    pano:"./SALA1_1c.jpg",
    marks: [
      {
        id: "mark1",
        polylineRad: [
          [0.689, 0.29],
          [0.689, -0.31],
          [2.425, -0.3],
          [2.425, 0.285],
          [0.689, 0.29]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea del tiempo del siglo XIX",
          position: "right bottom"
        },
        info: {
          title: "Línea del tiempo del siglo XIX",
          template: "sala1timeline",
          images: [
            "galerias/sala1/S1_G1.jpg"
          ]
        }
      },
      {
        id: "mark0",
        polylineRad: [
          [3.52, 0.24],
          [3.52, -0.19],
          [4.10, -0.4],
          [4.10, 0.49],
          [3.52, 0.24]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Video bienvenida",
          position: "right bottom"
        },
        info: {
          template: "s1_p1g00",
          images: [
          ],
          audios: [
          ]
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [2.428, 0.101],
          [2.429, -0.08],
          [2.507, -0.085],
          [2.508, 0.108],
          [2.428, 0.101]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "México en el siglo XIX",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g02",
          images: [
            "galerias/sala1/S1_G2.jpg",
            "galerias/sala1/S1_G2_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G2.mp3",
            "audios/sala1/en/S1_G2.mp3"
          ]
        }
      },
      {
        id: "exit:sala1_2:0", // cmd, arg, marker id
        polylineRad: [
          [2.75, -0.29],
          [2.518, -0.43],
          [2.99, -0.52],
          [3.059, -0.31],
          [2.75, -0.29]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [2.95, 0.14],
          [2.95, -0.24],
          [3.295, -0.24],
          [3.296, 0.141],
          [2.95, 0.14],
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa Sala 2",
          position: "center bottom"
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [-1.291, 0.365],
          [-0.66, 0.24],
          [-0.665, -0.41],
          [-1.291, -0.59],
          [-1.291, 0.365],
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      }
    ]
  },
  sala1_2:{
    pano:"./SALA1_2c.jpg",
    marks: [
      {
        id: "mark1",
        polylineRad: [
          [4.397, 0.116],
          [4.398, -0.093],
          [4.452, -0.093],
          [4.452, 0.117],
          [4.397, 0.116]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea del tiempo del siglo XIX",
          position: "right bottom"
        },
        info: {
          title: "Línea del tiempo del siglo XIX",
          template: "sala1timeline",
          images: [
            "galerias/sala1/S1_G1.jpg"
          ]
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [4.163, 0.099],
          [4.164, -0.174],
          [4.252, -0.147],
          [4.254, 0.084],
          [4.163, 0.099]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa Sala 2",
          position: "center bottom"
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [3.556, 0.163],
          [3.556, -0.128],
          [3.898, -0.103],
          [3.897, 0.13],
          [3.556, 0.163]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "México en el siglo XIX",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g02",
          images: [
            "galerias/sala1/S1_G2.jpg",
            "galerias/sala1/S1_G2_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G2.mp3",
            "audios/sala1/en/S1_G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [2.884, 0.172],
          [2.884, -0.134],
          [3.373, -0.134],
          [3.373, 0.172],
          [2.884, 0.172]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las principales potencias internacionales",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g03",
          images: [
            "galerias/sala1/S1_G3.jpg",
            "galerias/sala1/S1_G3_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G3.mp3",
            "audios/sala1/en/S1_G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [
          [2.36, 0.128],
          [2.36, -0.1],
          [2.685, -0.127],
          [2.685, 0.161],
          [2.36, 0.128]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Primera Intervención Francesa",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g04",
          images: [
            "galerias/sala1/S1_G4.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G4.mp3",
            "audios/sala1/en/S1_G4.mp3"
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [
          [1.731, 0.147],
          [1.731, -0.116],
          [2.094, -0.101],
          [2.094, 0.129],
          [1.731, 0.147]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Guerra México-Estados Unidos (1846-1848)",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g05",
          images: [
            "galerias/sala1/S1_G5.jpg",
            "galerias/sala1/S1_G5_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G5.mp3",
            "audios/sala1/en/S1_G5.mp3"
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [
          [1.059, 0.13],
          [1.059, -0.10],
          [1.429, -0.115],
          [1.429, 0.147],
          [1.059, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Guerra de Reforma",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g06",
          images: [
            "galerias/sala1/S1_G6.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G6.mp3",
            "audios/sala1/en/S1_G6.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [0.495, 0.188],
          [0.495, -0.154],
          [0.77, -0.128],
          [0.77, 0.150],
          [0.495, 0.188]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Suspensión de pagos",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g07",
          images: [
            "galerias/sala1/S1_G7.png",
            "galerias/sala1/S1_G7_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G7.mp3",
            "audios/sala1/en/S1_G7.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [6.107, 0.178],
          [6.107, -0.142],
          [0.321, -0.136],
          [0.321, 0.173],
          [6.107, 0.178]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Convención de Londres",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g08",
          images: [
            "galerias/sala1/S1_G8.jpg",
            "galerias/sala1/S1_G8_SUB.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G8.mp3",
            "audios/sala1/en/S1_G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [5.50, 0.13],
          [5.50, -0.101],
          [5.836, -0.129],
          [5.835, 0.164],
          [5.50, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Los tratados de La Soledad",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g09",
          images: [
            "galerias/sala1/S1_G9.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G9.mp3",
            "audios/sala1/en/S1_G9.mp3"
          ]
        }
      },
      {
        id: "mark10",
        polylineRad: [
          [4.795, 0.224],
          [4.795, -0.237],
          [5.169, -0.213],
          [5.169, 0.2],
          [4.795, 0.224]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Inminente invasión",
          position: "right bottom"
        },
        info: {
          template: "s1_p2g10",
          images: [
            "galerias/sala1/S1_G10.jpg"
          ],
          audios: [
            "audios/sala1/es/S1_G10.mp3",
            "audios/sala1/en/S1_G10.mp3"
          ]
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [4.46, -0.32],
          [4.065, -0.267],
          [3.832, -0.359],
          [4.303, -0.495],
          [4.46, -0.32]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala2_1:{
    pano:"./SALA2_1c.jpg",
    marks: [
      {
        id: "mark0",
        polylineRad: [
          [4.018, 0.441],
          [4.018, -0.357],
          [5.426, -0.351],
          [5.428, 0.433],
          [4.018, 0.441]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Video de bienvenida a la sala",
          position: "right bottom"
        },
        info: {
          template: "s2_p1g00",
          images: [
          ]
        }
      },
      {
        id: "mark1",
        polylineRad: [
          [0.68, 0.281],
          [0.68, -0.303],
          [2.46, -0.317],
          [2.46, 0.295],
          [0.68, 0.281]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Posiciones del ejército de Oriente, febrero de 1862",
          position: "right bottom"
        },
        info: {
          template: "s2_p1g01",
          images: [
            "galerias/sala2/S2_G1.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G1.mp3",
            "audios/sala2/en/S2_G1.mp3"
          ]
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [0.616, 0.108],
          [0.616, -0.086],
          [0.679, -0.081],
          [0.678, 0.103],
          [0.616, 0.108]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El avance francés hacia la capital",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g02",
          images: [
          ]
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [5.75, 0.195],
          [5.75, -0.325],
          [5.91, -0.24],
          [5.91, 0.14],
          [5.75, 0.195]
      
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [6.11, 0.14],
          [6.11, -0.24],
          [0.18, -0.24],
          [0.18, 0.14],
          [6.11, 0.14]
      
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Regresa Sala 1",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala2_2:0", // cmd, arg, marker id
        polylineRad: [
          [0.317, -0.277],
          [0.05, -0.29],
          [0.1, -0.49],
          [0.49, -0.43],
          [0.317, -0.277]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala3_1:0", // cmd, arg, marker id
        polylineRad: [
          [2.78, 0.28],
          [2.78, -0.45],
          [3.48, -0.45],
          [3.48, 0.28],
          [2.78, 0.28]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa Sala 3",
          position: "center bottom"
        }
      }
    ]
  },
  sala2_2:{
    pano:"./SALA2_2c.jpg",
    marks: [
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [4.963, 0.082],
          [4.963, -0.14],
          [5.105, -0.132],
          [5.105, 0.079],
          [4.963, 0.082]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [5.152, 0.086],
          [5.152, -0.146],
          [5.256, -0.172],
          [5.256, 0.105],
          [5.152, 0.086]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Regresa Sala 1",
          position: "center bottom"
        }
      },
      {
        id: "mark2",
        polylineRad: [          
          [5.523, 0.131],
          [5.521, -0.103],
          [5.863, -0.13],
          [5.862, 0.165],
          [5.523, 0.131],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El avance francés hacia la capital",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g02",
          images: [
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [          
          [6.045, 0.176],
          [6.045, -0.137],
          [0.259, -0.137],
          [0.259, 0.174],
          [6.045, 0.176],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La estrategia militar de Zaragoza",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g03",
          images: [
            "galerias/sala2/S2_G3.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G3.mp3",
            "audios/sala2/en/S2_G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [          
          [0.462, 0.161],
          [0.462, -0.126],
          [0.788, -0.1],
          [0.788, 0.127],
          [0.462, 0.161],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Atlixco, 4 de mayo de 1862",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g04",
          images: [
            "galerias/sala2/S2_G4.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G4.mp3",
            "audios/sala2/en/S2_G4.mp3"
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [          
          [1.019, 0.127],
          [1.019, -0.1],
          [1.375, -0.113],
          [1.377, 0.146],
          [1.019, 0.127],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Batalla del 5 de Mayo de 1862",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g05",
          images: [
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [ 
          [1.68, 0.283],
          [1.68, -0.247],
          [2.01, -0.229],
          [2.01, 0.259],
          [1.68, 0.283],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Una victoria gloriosa",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g06",
          images: [
            "galerias/sala2/S2_G6.jpg",
            "galerias/sala2/S2_G6_SUB.jpg",
            "galerias/sala2/S2_G6_SUB2.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G6.mp3",
            "audios/sala2/en/S2_G6.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [          
          [2.455, 0.169],
          [2.457, -0.092],
          [2.593, -0.099],
          [2.59, 0.184],
          [2.455, 0.169],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Reconocimiento de Juárez a los combatientes",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g07",
          images: [
            "galerias/sala2/S2_G7.png",
            "galerias/sala2/S2_G7_SUB.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G7.mp3",
            "audios/sala2/en/S2_G7.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [          
          [3.074, 0.208],
          [3.074, -0.171],
          [3.753, -0.139],
          [3.753, 0.17],
          [3.074, 0.208],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g08",
          images: [
            "galerias/sala2/S2_G8.jpg",
            "galerias/sala2/S2_G8_SUB.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G8.mp3",
            "audios/sala2/en/S2_G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [          
          [4.096, 0.177],
          [4.096, -0.187],
          [4.779, -0.234],
          [4.781, 0.221],
          [4.096, 0.177],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Patricio Ramos y Ortega, combatiente y pintor",
          position: "right bottom"
        },
        info: {
          template: "s2_p2g09",
          images: [
            "galerias/sala2/S2_G9.jpg"
          ],
          audios: [
            "audios/sala2/es/S2_G9.mp3",
            "audios/sala2/en/S2_G9.mp3"
          ]
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [5.02, -0.31],
          [5.16, -0.48],
          [5.63, -0.33],
          [5.40, -0.25],
          [5.02, -0.31]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala3_1:{
    pano:"./SALA3_1c.jpg",
    marks: [
      {
        id: "g01",
        polylineRad: [
          [0.67, 0.29],
          [0.67, -0.31],
          [2.45, -0.31],
          [2.45, 0.28],
          [0.67, 0.29]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La conmemoración de la batalla",
          position: "right bottom"
        },
        info: {
          title: "La conmemoración de la batalla",
          template: "s3_p1g01",
          images: [
            "galerias/sala3/S3_G1.jpg"
          ],
          audios: [
            "audios/sala3/es/S3_G1.mp3",
            "audios/sala3/en/S3_G1.mp3"
          ]
        }
      },
      {
        id: "g00",
        polylineRad: [
          [3.54, 0.23],
          [3.54, -0.19],
          [4.12, -0.38],
          [4.12, 0.47],
          [3.54, 0.23]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "VIDEO INTRODUCTORIO",
          position: "right bottom"
        },
        info: {
          title: "VIDEO INTRODUCTORIO",
          template: "s3_p1g00",
          images: [
          ],
          audios: [
          ]
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [5, 0.35],
          [5, -0.55],
          [5.605, -0.39],
          [5.605, 0.24],
          [5, 0.35]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [5.93, 0.29],
          [5.93, -0.46],
          [0.37, -0.46],
          [0.37, 0.29],
          [5.93, 0.29]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Regresa Sala 2",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala3_2:0", // cmd, arg, marker id
        polylineRad: [
          [2.55, -0.46],
          [3.04, -0.54],
          [3.1, -0.3],
          [2.82, -0.29],
          [2.55, -0.46]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala3_2:{
    pano:"./SALA3_2c.jpg",
    marks: [
      {
        id: "g00",
        polylineRad: [
          [4.401, 0.117],
          [4.4, -0.095],
          [4.457, -0.095],
          [4.458, 0.119],
          [4.401, 0.117]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "VIDEO INTRODUCTORIO",
          position: "right bottom"
        },
        info: {
          title: "VIDEO INTRODUCTORIO",
          template: "s3_p1g00",
          images: [
          ],
          audios: [
          ]
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [3.37, 0.18],
          [3.37, -0.145],
          [3.79, -0.12],
          [3.79, 0.15],
          [3.37, 0.18]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El avance francés hacia la capital",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g02",
          images: [
          ],
          audios: [
            "audios/sala3/es/S3_G2.mp3",
            "audios/sala3/en/S3_G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [2.46, 0.145],
          [2.46, -0.115],
          [2.86, -0.14],
          [2.86, 0.18],
          [2.46, 0.145]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El fuerte de Guadalupe",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g03",
          images: [
            "galerias/sala3/S3_G3.jpg",
            "galerias/sala3/S3_SubG3.jpg"
          ],
          audios: [
            "audios/sala3/es/S3_G3.mp3",
            "audios/sala3/en/S3_G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [
          [1.765, 0.145],
          [1.765, -0.115],
          [2.12, -0.10],
          [2.12, 0.125],
          [1.765, 0.145]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El fuerte de Loreto",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g04",
          images: [
            "galerias/sala3/S3_G4.jpg",
            "galerias/sala3/S3_SubG4.jpg"
          ],
          audios: [
            "audios/sala3/es/S3_G4.mp3",
            "audios/sala3/en/S3_G4.mp3"
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [
          [1.02, 0.125],
          [1.02, -0.1],
          [1.37, -0.115],
          [1.37, 0.145],
          [1.02, 0.125]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Arco de Loreto",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g05",
          images: [
            "galerias/sala3/S3_G5.jpg",
            "galerias/sala3/S3_SubG5.jpg",
          ],
          audios: [
            "audios/sala3/es/S3_G5.mp3",
            "audios/sala3/en/S3_G5.mp3"
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [
          [0.47, 0.16],
          [0.47, -0.125],
          [0.79, -0.1],
          [0.79, 0.125],
          [0.47, 0.16]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Iglesia de los Remedios",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g06",
          images: [
            "galerias/sala3/S3_G6.jpg",
            "galerias/sala3/S3_SubG6.jpg"
          ],
          audios: [
            "audios/sala3/es/S3_G6.mp3",
            "audios/sala3/en/S3_G6.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [6.06, 0.175],
          [6.06, -0.14],
          [0.275, -0.138],
          [0.275, 0.175],
          [6.06, 0.175]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Monumento al General Ignacio Zaragoza",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g07",
          images: [
            "galerias/sala3/S3_G7.jpg",
            "galerias/sala3/S3_SubG7.png"
          ],
          audios: [
            "audios/sala3/es/S3_G7.mp3",
            "audios/sala3/en/S3_G7.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [5.532, 0.13],
          [5.532, -0.104],
          [5.88, -0.13],
          [5.88, 0.165],
          [5.532, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Cerro de Amalucan",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g08",
          images: [   
            "galerias/sala3/S3_G8.jpg",
            "galerias/sala3/S3_SubG8.jpg"         
          ],
          audios: [
            "audios/sala3/es/S3_G8.mp3",
            "audios/sala3/en/S3_G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [4.46, 0.21],
          [4.46, -0.22],
          [5.42, -0.175],
          [5.42, 0.16],
          [4.46, 0.21]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Ciudad de Puebla a 160 años del 5 de mayo",
          position: "right bottom"
        },
        info: {
          title: "",
          template: "s3_p2g09",
          images: [
            "galerias/sala3/S3_G9.jpg",
            "galerias/sala3/S3_SubG9.jpg"   
          ],
          audios: [
            "audios/sala3/es/S3_G9.mp3",
            "audios/sala3/en/S3_G9.mp3"
          ]
        }
      },
      {
        id: "exit:sala3_1:0",
        polylineRad: [
          [4.05, -0.267],
          [3.86, -0.354],
          [4.38, -0.497],
          [4.48, -0.33],
          [4.05, -0.267]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Regresa parte 1",
          position: "center bottom"
        }
      }
    ]
  }
};
